<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

const { records, isSelected } = defineProps<{
  records: any[],
  isSelected: Function,
}>()

const emit = defineEmits(['set', 'getRecords', 'select', 'unselect', 'isSelected'])
</script>

<template>
  <VTable v-if="records?.length">
    <thead>
      <tr>
        <th>Название</th>
        <th class="text-center mw-100">
          Действие
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="record in records"
        :key="record.Bundle?.Uuid"
      >
        <td>{{ record.Name }}</td>
        <td class="text-center">
          <WidgetRecordAction
            :selected="isSelected(record.Bundle?.Uuid)"
            @set="emit('select', record)"
            @delete="emit('unselect', record)"
          />
        </td>
      </tr>
    </tbody>
  </VTable>

  <VListItem v-else>
    Нет данных.
  </VListItem>
</template>